<template>
  <div>
    <div class="map__container map__container_up">
      <div class="map__title city-show">
        <div class="h1">
          <h1>Найти отделение</h1>
          <span>&nbsp;в&nbsp;</span>
        </div>
        <OdpListCitySelect
          :city="selectedCity"
          @select="onCitySelect"
        />
      </div>

      <MapTabs
        :tab-active="deliveryLap ? 'deliveryLap' : 'receptionLap'"
        @changeTab="onChangeTab"
      />

      <div class="map-nav">
        <div class="map-nav__items">
          <div
            class="map-nav__item empty"
            :style="(!odpInViewPort && !showList) || hideMapWithoutOdp ? '' : 'opacity: 0; position: absolute;'"
          >
            Ничего не
            найдено
          </div>
          <div
            id="foundPoint"
            ref="foundPoint"
            class="map-nav__item"
            :style="odpInViewPort && !hideMapWithoutOdp ? '' : 'opacity: 0; position: absolute;'"
          >
            0 отделений
          </div>
          <div
            id="courierPoint"
            ref="courierPoint"
            class="map-nav__item"
            :style="isCourier && !hideMapWithoutOdp ? '' : 'opacity: 0; position: absolute;'"
          >
            Курьерская доставка
          </div>
        </div>
        <div
          class="map-nav__button-cont"
        >
          <a
            v-if="!hideMapWithoutOdp && enableList"
            class="map-nav__button map-nav__button_filial"
            @click="() => {
              showList = !showList;
              updateFilterUrl();
            }"
          >
            <template v-if="showList">
              <span class="map-nav__button-text">
                <svg
                  class="geo-multi-icon"
                  width="18px"
                  height="20px"
                >
                  <use xlink:href="#geo-multi" />
                </svg>
                Показать на карте
              </span>
            </template>

            <template v-if="!showList">
              <span class="map-nav__button-text">
                <svg
                  class="list-multi-icon"
                  width="20px"
                  height="15px"
                >
                  <use xlink:href="#list-multi" />
                </svg>
                Показать списком
              </span>
            </template>
          </a>

          <a
            class="map-nav__button map-nav__button_submenu"
            :class="{ 'map-nav__button_active': showFilter }"
            @click="showFilter = !showFilter"
          >
            <span class="d-flex align-items-center">
              <svg
                class="filter-icon me-3"
                width="16" height="16" viewBox="0 0 16 16"
              >
                <path d="M0.576543 3.36034C-0.192181 2.59162 -0.192181 1.34527 0.576543 0.576543C1.34527 -0.192181 2.59162 -0.192181 3.36034 0.576543L15.4235 12.6397C16.1922 13.4084 16.1922 14.6547 15.4235 15.4235C14.6547 16.1922 13.4084 16.1922 12.6397 15.4235L0.576543 3.36034Z" fill="#ED1651"/>
                <path d="M15.4235 3.36034C16.1922 2.59162 16.1922 1.34527 15.4235 0.576543C14.6548 -0.192181 13.4084 -0.192181 12.6397 0.576543L0.576582 12.6397C-0.192142 13.4084 -0.192142 14.6547 0.576582 15.4235C1.34531 16.1922 2.59165 16.1922 3.36038 15.4235L15.4235 3.36034Z" fill="#ED1651"/>
              </svg>
              Фильтры
            </span>

            <div class="map-nav__submenu">
              <template v-if="!filterOnlyReceptionLaP">
                <div class="map-nav__submenu-item">
                  <div class="field-checkbox field-checkbox_switch">
                    <input
                      id="interRefunds"
                      v-model="interRefunds"
                      class="field-checkbox__input"
                      type="checkbox"
                      @change="(e) => changeFilters(e)"
                    >
                    <label
                      class="field-checkbox__label"
                      for="interRefunds"
                    >Международные отправления</label>
                  </div>
                </div>
              </template>

            </div>

          </a>
        </div>
      </div>
    </div>

    <PointList
      v-if="enableList"
      :style="showList ? '' : 'opacity: 0; position: absolute; width: 0; height: 0; display: none;'"
      :is-open-on-weekends="isOpenOnWeekends"
      :acquiring="acquiring"
      :inter-refunds="interAll"
      :reception-lap="receptionLap"
      :init-points-data="initPointsDataList"
      :show-list="showList"
      :build-route="buildRoute"
      :enable-courier="enableCourier"
      :enable-o-d-p-view-port="enableODPViewPort"
      :search-query-o-d-p="searchQueryODP"
      :init-city-code="initCityCode"
      :odp-page-query-string="odpPageQueryString"
      :set-odp-search-query="setOdpSearchQuery"
      :selected-city="selectedCity"
      :filter-params="filterParams"
    />

    <div
      style="width: 100%; position: relative;padding-bottom: 95px;"
      :style="!showList ? '' : 'opacity: 0; visibility: hidden; position: absolute; left: 0; right: 0; padding-bottom: 0;'"
    >
      <div
        class="map__container"
        style="position:relative;"
      >
        <div
          v-if="ODPPreview !== null && desktopDevice"
          class="map__frame-cont active"
        >
          <ODPPreviewModal
            class="map__container map__container_card"
            :o-d-p-preview="ODPPreview"
            :build-route="buildRoute"
            :hide-o-d-p-preview="hideODPPreview"
            :odp-page-query-string="odpPageQueryString"
            :absoluteUrl="absoluteUrl"
            :showLinkToOffice="!absoluteUrl"
          />
        </div>

        <YmapsView
          ref="ymapsView"
          style="width: 100%; height: 676px;"
          :show-o-d-p-preview="showODPPreview"
          :reception-lap="receptionLap"
          :delivery-lap="deliveryLap"
          :inter-refunds="interRefunds"
          :show-list="showList"
          :selected-city="selectedCity"
          :cityCode="code"
          :hide-map-without-odp="hideMapWithoutOdp"
          @change-hide-map-without-odp="hideMapWithoutOdp = $event"
        />

        <div
          v-if="ODPPreview !== null && !desktopDevice"
          id="odpPreview"
          class="map__frame-cont active"
        >
          <ODPPreviewModal
            class="map__container map__container_card"
            :o-d-p-preview="ODPPreview"
            :build-route="buildRoute"
            :hide-o-d-p-preview="hideODPPreview"
            :odp-page-query-string="odpPageQueryString"
            :element-map="this.$refs.ymapsView"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
import YmapsView from './YmapsView.vue';
import PointList from '../PointList/PointList.vue';
import ODPPreviewModal from '../MapWidget/ODPPreviewModal.vue';
import OdpListCitySelect from './OdpListCitySelect.vue';

import { getters as cityGetters } from '../../store/city.store';
import URL from '../../helpers/url';
import { actions as cityRepositoryActions, getters as cityRepositoryGetters } from '../../store/city.repository';
import { COUNTRY_CODES } from '../../helpers/constans';
import loadYmaps from '../../helpers/ymaps-loader';
import MapTabs from '../mapComponent/MapTabs.vue';
import mapTabsMixin from '../../mixins/mapTabsMixin';
import num2str from '../../helpers/num2str';

const emptyMapJson = () => import(
  /* webpackChunkName: "emptyMapJson" */
  '../emptyMap.json'
);
const _ = require('lodash');
const axios = require('axios');
const matchAll = require('string.prototype.matchall');

// eslint-disable-next-line
const NEW_API_URL = apiUrl;

export default {
  name: 'MapWidgetFind',
  components: {
    MapTabs,
    OdpListCitySelect,
    YmapsView,
    ODPPreviewModal,
    PointList,
  },
  mixins: [mapTabsMixin],
  props: {
    msg: {
      type: String,
      default: '',
    },
    absoluteUrl: {
      type: String,
      default: '',
    },
    enableList: {
      type: Boolean,
      default: true,
    },
    filterOnlyReceptionLaP: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      initCityCode: '',
      OdpPage: false,
      ODPPreview: null,
      showList: false,
      showFilter: false,
      changeGlobal: '',
      queryString: [],
      interRefunds: false,
      interShipping: false,
      acquiring: false,
      isOpenOnWeekends: false,
      initListCollection: [],
      initPointsData: {},
      initPointsDataList: {},
      isCourier: false,
      searchODP: '',
      cityNameLocal: '',
      cityCodeLocal: '',
      odpInViewPort: true,
      searchQueryODP: '',
      userCity: '',
      programUrl: '',
      cityLocalQuery: '',
      cities: [],

      userSelectedCity: null,
      desktopDevice: window.innerWidth >= 1050,
      loadingCities: true,
      hideMapWithoutOdp: false,
    };
  },
  computed: {
    ...cityGetters,
    selectedCity() {
      return this.userSelectedCity || { Code: cityGetters.code(), Name: cityGetters.name() };
    },
    odpPageQueryString() {
      const filterParams = this.getFilterQueryParams();

      if (this.userSelectedCity) {
        filterParams.push(`cityLocal=${encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(this.userSelectedCity))))}`);
      }

      return `from=${encodeURIComponent(btoa(encodeURIComponent(filterParams.join('&'))))}`;
    },
    interAll() {
      return this.interShipping || this.interRefunds;
    },
    countryCode() {
      if (!this.selectedCity || this.loadingCities) return '';
      const city = cityRepositoryActions.find(this.selectedCity.Code);
      if (city && city[0] && city[0].Country_code) {
        return city[0].Country_code;
      }
      return '';
    },
    filterParams() {
      return this.countryCode === COUNTRY_CODES.UZBEKISTAN ? 'deliveryLap=1' : 'filter=pip';
    },
  },
  watch: {
    selectedCity(newValue) {
      if (newValue) {
        this.ODPPreview = null;
        // this.setQueryParamsForODPPage(newValue.Code);
      }
    },
    filterParams: {
      handler(val) {
        if (this.selectedCity && val === 'deliveryLap=1') {
          this.getInitPoints(this.selectedCity.Code);
        }
      },
      immediate: true,
    },
  },
  beforeMount() {
    loadYmaps().then(() => {
      if (cityRepositoryGetters.cities().length) {
        if (this.selectedCity) {
          this.getInitPoints(this.selectedCity.Code);
        }
      }
    });
    cityRepositoryActions.load().then(() => {
      this.loadingCities = false;
    });
  },
  mounted() {
    const self = this;

    this.loadCityFromUrl();
    if (this.redirectUrl) {
      window.history.pushState(window.location.origin, null, this.redirectUrl);
    }

    // Проверка перехода со страницы e-commerce?
    if (localStorage.getItem('userCity')) {
      const userCity = JSON.parse(localStorage.getItem('userCity'));

      if (userCity.CourierDelivery === 0) {
        this.isCourier = false;
      } else if (userCity.CourierDelivery === 1) {
        this.isCourier = true;
      }
    }

    const url = new URL(window.location.href);
    _.forEach(url.searchParams, (param, key) => {
      if (key === 'view' && param === 'list') {
        self.showList = true;
      }

      if (key === 'Search') {
        self.searchQueryODP = param;
      }

      if (key === 'acquiring') {
        self.acquiring = param === '1';
      }

      if (key === 'isOpenOnWeekends') {
        self.isOpenOnWeekends = param === '1';
      }

      if (key === 'interShipping') {
        self.interShipping = param === '1';
      }

      if (key === 'interRefunds') {
        self.interRefunds = param === '1';
      }

      if (key === 'receptionLap') {
        self.receptionLap = param === '1';
      }
      if (key === 'deliveryLap') {
        self.deliveryLap = param === '1';
      }
    });

    if (this.selectedCity) {
      this.getInitPoints(this.selectedCity.Code);
    }
    // Это делается теперь в watch odpPageQueryString
    // if (this.userSelectedCity) {
    //   // присвоим значение кода города и параметр вида из строки url, для создания ссылки обратно в поиск отделений,
    //   // со страницы отделения. /find_an_office/:id
    //   this.odpPageQueryString = window.location.search;
    // }

    window.addEventListener('resize', () => {
      this.desktopDevice = window.innerWidth >= 1050;
    });
  },
  methods: {
    setOdpSearchQuery(string) {
      this.searchQueryODP = string;
      this.updateFilterUrl();
    },
    hideODPPreview() {
      this.ODPPreview = null;
    },
    enableODPViewPort(boolean) {
      this.odpInViewPort = !!boolean;
    },
    enableCourier(boolean) {
      this.isCourier = !!boolean;
    },
    changeFilters(e) {
      if (this[e.target.id]) {
        this.queryString.push(e.target.id);
      } else {
        const index = this.queryString.indexOf(e.target.id);
        if (index > -1) {
          this.queryString.splice(index, 1);
        }
      }
      this.updateFilterUrl();
    },
    /**
     * Возвращает массив с параметрами фильтра, кроме тех, значения которых соответствуют значениям по умолчанию
     *
     * @return Array
     */
    getFilterQueryParams() {
      const params = [];

      if (this.isOpenOnWeekends === true) { params.push(`isOpenOnWeekends=${1}`); }
      if (this.acquiring === true) { params.push(`acquiring=${1}`); }
      if (this.interRefunds === true) { params.push(`interRefunds=${1}`); }
      if (this.interShipping === true) { params.push(`interShipping=${1}`); }
      if (this.receptionLap === true) { params.push(`receptionLap=${1}`); }
      if (this.searchQueryODP.length) { params.push(`Search=${this.searchQueryODP}`); }
      params.push(this.showList ? 'view=list' : 'view=map');

      return params;
    },
    updateFilterUrl() {
      const queryParams = this.getFilterQueryParams();

      window.history.pushState(window.location.origin, null, `?${queryParams.join('&')}`);

      // // После изменения фильтров, обновим данные query параметров, для возврата в исходной состояние.
      // this.setQueryParamsForODPPage(this.cityCodeLocal);
    },
    buildRoute(e, odp, list) {
      e.preventDefault();
      // Берем и узнаем положение пользователя, если мы его не узнаем, все тлен.
      this.$refs.ymapsView.getUserLocation(odp);
      this.ODPPreview = odp;
      if (list) {
        this.showList = false;
      }
    },
    showODPPreview(odp) {
      this.ODPPreview = odp.data;
      this.$bvModal.show('ODPPreviewModal');
    },
    filtered() {
      if (this.search.length) {
          const r = _.filter(this.cities, (v) => (v.Name.toLowerCase().includes(this.search.toLowerCase()))); // eslint-disable-line
        return r;
      }
      return this.cities;
    },
    getInitPoints(code) {
      const self = this;
      self.initCityCode = code.toString();

      const isOpenOnWeekends = this.isOpenOnWeekends === true ? `&isOpenOnWeekends=${1}` : '';
      const acquiring = this.acquiring === true ? `&acquiring=${1}` : '';
      const interAll = this.interAll === true ? `&interRefunds=${1}` : '';
      const receptionLap = this.receptionLap === true ? `&receptionLap=${1}` : '';

      const queryParams = isOpenOnWeekends + acquiring + interAll + receptionLap;

      axios.get(`${NEW_API_URL}/odp?cityCode=${code}&select=title,address,id,workTime,geo,fitting,fittingType,courierDelivery,acquiring,receptionLap&perPage=10${queryParams}`)
        .then((resp) => {
          if (!resp.data || !resp.data.pager) return;
          if (resp.data.pager.nbResults) {
            // eslint-disable-next-line no-undef
            self.$refs.foundPoint.innerHTML = resp.data.pager.nbResults + num2str(resp.data.pager.nbResults,
              [' отделение', ' отделения', ' отделений']);
          }
          self.initPointsData = resp;
          self.initPointsDataList = resp;
        })
        .catch(() => {
          self.initPointsData = null;
          emptyMapJson().then((module) => {
            self.initPointsData = module.default;
          });
        });
    },
    // setQueryParamsForODPPage(code) {
    //   const cityCodeQuery = window.location.search ? '&cityLocal=' : '?cityLocal=';
    //   this.odpPageQueryString = window.location.search + cityCodeQuery + code;
    // },
    onCitySelect(city) {
      this.userSelectedCity = city;
    },
    /**
     * Загружает данные о выбранном городе из URL.
     * Если в строке есть несколько параметров, содержащих закодированный город, будет загружен город из последнего
     * по порядку следования, содержащего правильно закодированную информацию о городе.
     *
     * Запоминает найденный параметр и записывает URL с вырезанным параметром в this.redirectUrl
     *
     */
    loadCityFromUrl() {
      let result;
      const cityMatches = [...matchAll(window.location.href, /[?&](cityLocal=(.+?)(&|$))/g)];

      // eslint-disable-next-line no-plusplus
      for (let i = cityMatches.length - 1; i >= 0; i--) {
        try {
          result = JSON.parse(decodeURIComponent(atob(decodeURIComponent(cityMatches[i][2]))));

          if (result) {
            this.userSelectedCity = result;

            this.redirectUrl = window.location.href
              .replace(cityMatches[i][1], '')
              .replace(/([&?])$/, '');
          }

          break;
        } catch {
          // Город не декодировался. Просто пропускаем.
        }
      }
    },

  },
};
</script>

<style lang="scss" scoped>

  /*.map__frame-cont {
    position: absolute;
    top: 0;
    right: 0;

    @media(max-width: 1050px) {
      position: static;
    }
  }
*/

  .map {

    &-nav {
      padding: 20px 0;

      &__submenu {

        @media (max-width: 767px) {
          padding-top: 48px;
        }
        &-item {

          &:nth-child(1)::before {
            left: 0;
            right: 0;
          }

          &:nth-child(2)::before {
            left: 30px;
            right: 30px;
          }
        }
      }

      &__text-hidden {
        @media (min-width: 768px) {
          display: none;
          position: absolute;
          visibility: hidden;
        }
      }

      &__button {

        &_active {

          .map-nav__button-text {

            .map-nav__text-hidden {
              display: block;
            }
          }
        }
      }
    }
  }

  .map__container_up {
    padding-top: 35px;
    position: relative;
    z-index: 99;

    @media (max-width: 767px) {
      margin-bottom: 20px;

      .map-nav {
        padding: 0 !important;
      }

      .formbar-fields {
        margin-left: 0 !important;
        margin-right: 0 !important;
      }
    }
  }

  .map-nav__button {

    &_submenu {
      min-width: 153px;
      max-width: 153px;
      margin: 0 !important;
      margin-left: 16px !important;

      .map-nav__submenu {
        width: 320px;
        left: -167px;
        top: 100%;
        box-shadow: 0 8px 15px 0 #00000033 !important;
        height: 47px;
      }

      .close-icon {
        position: absolute;
        left: 220px;
        top: -20px;

        @media (max-width: 767px) {
          display: none;
        }
      }

      @media (max-width: 600px) {
        max-width: 320px;
        margin: 0 !important;
        margin-top: 10px !important;
        margin-bottom: 10px !important;

        .map-nav__text-hidden {
          display: block;
        }
      }

      @media (max-width: 580px) {
        max-width: none;

        .map-nav__submenu {
          width: 100%;
          left: 0;
          right: 0;
          top: 100%;
        }
      }

      .filter-icon {
        margin-right: 0;
      }
    }

    &_active {
      @media (min-width: 768px) {
        .map-nav {

          &__button-text {
            top: 30px;
            left: -190px;
          }

          &__text-hidden {
            position: initial;
            min-width: 152px;
            visibility: visible;
          }
        }
      }

      @media (min-width: 601px) {
        .map-nav {

          &__button-text {
            left: -190px;
          }
        }
      }
    }
  }

  @media (min-width: 1050px) {

  .map__frame-cont {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;

    .map__container {
      height: 100%;

      >>> .map-card {
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}

@media (min-width: 1050px) {

  .map__frame-cont {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;

    .map__container {
      height: 100%;

      >>> .map-card {
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}

.map__title {
  @media(min-width: 768px) {
    text-align: center;
  }
  border: none;
  .city-name {
    display: inline-block;
    vertical-align: baseline;
  }

  .h1 {
    display: inline-block;
    vertical-align: baseline;

    h1, span {
      display: inline-block;
      vertical-align: baseline;
    }

    span {
      white-space: pre;
    }
  }
}
.map-nav__button-text {
  max-width: 228px;
}
.map-nav__button_submenu {
  height: 50px !important;
}
.map-nav__button_active {
  .map-nav__submenu {
    padding: 0;
  }
  &.map-nav__button_submenu {
    box-shadow: 0 8px 15px 0 #00000033;
  }
}
</style>
